// extracted by mini-css-extract-plugin
module.exports = {"drugList":"drugError_drugList__1Luwy","drug":"drugError_drug__XgSwL"};